import React from 'react';
import '../assets/App.scss';
import '../assets/globalStyles.css';

const FooterCartMenu = (props) => {
  return (
    <div className="level is-mobile py-1">
      <div className="level-left">
        <div className="level-item">
          <p>
            <strong className="pink is-size-7">
              {props.title}
            </strong>
            <br />
            <strong className="has-text-black font-medium">
              Rp {props.totalPrice}
            </strong>
          </p>
        </div>
      </div>

      <div className="level-right">
        <button disabled={props.disabled} onClick={() => props.addToCart(props.id)} className="button pay ml-1">
          <strong>{props.textButton}</strong>
        </button>
      </div>
    </div>
  )
}

export default FooterCartMenu;
